<mat-card-header>
	<mat-card-title class="h5">
		Workflows
	</mat-card-title>
</mat-card-header>
<mat-divider> </mat-divider>

<div *ngIf="results.length > 0" class="margin-top-md">
	<mat-table [dataSource]="tableDataSources[0]" class="table-responsive mat-elevation-z1" matSort>
		<ng-container matColumnDef="EDIT">
			<mat-header-cell *matHeaderCellDef> </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<a mat-icon-button color="primary" matTooltip="Edit" [routerLink]="'/workflows/edit/' + element.ID">
					<mat-icon>edit</mat-icon>
				</a>
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="NAME">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element.NAME}}
			</mat-cell>
		</ng-container>

		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
	</mat-table>

</div>